import React from 'react';
import { format } from 'date-fns';
import { Button } from '../ui/button';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { Eye, Briefcase, Send, CheckCircle, Trash2, MoreHorizontal } from 'lucide-react';

const TYPE_LABELS = {
  monthly: 'Mensuel',
  quarterly: 'Trimestriel',
  annual: 'Annuel',
};

export default function ReportCard({
  report,
  isAdmin,
  onPreview,
  onEditNotes,
  onSend,
  onPublish,
  onDelete,
}) {
  return (
    <div
      className="bg-white border border-neutral-200 hover:border-neutral-400 transition-all"
      data-testid={`report-card-${report.id}`}
    >
      <div className="p-4 border-b border-neutral-100">
        <div className="flex items-start justify-between">
          <div>
            <h3 className="font-medium text-neutral-900">{report.title}</h3>
            <p className="text-sm text-neutral-500">{report.client_name}</p>
          </div>
          <span className={`text-xs font-mono px-2 py-1 rounded ${
            report.status === 'published'
              ? 'bg-green-50 text-green-700'
              : 'bg-yellow-50 text-yellow-700'
          }`}>
            {report.status === 'published' ? 'Publié' : 'Brouillon'}
          </span>
        </div>
      </div>
      <div className="p-4">
        <div className="flex items-center gap-4 text-sm text-neutral-500 mb-4">
          <span className="font-mono">
            {format(new Date(report.period_start), 'dd/MM/yy')} - {format(new Date(report.period_end), 'dd/MM/yy')}
          </span>
          <span className="text-neutral-300">|</span>
          <span>{TYPE_LABELS[report.report_type]}</span>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          <Button variant="outline" size="sm" onClick={() => onPreview(report.id)}
                  data-testid={`preview-report-${report.id}`}>
            <Eye className="w-4 h-4 mr-1" /> Aperçu
          </Button>
          <Button variant="outline" size="sm" onClick={() => onEditNotes(report)}
                  data-testid={`edit-report-${report.id}`}>
            <Briefcase className="w-4 h-4 mr-1" /> Notes
          </Button>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="sm">
                <MoreHorizontal className="w-4 h-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={() => onSend(report)}>
                <Send className="w-4 h-4 mr-2" /> Envoyer
              </DropdownMenuItem>
              {report.status !== 'published' && (
                <DropdownMenuItem onClick={() => onPublish(report.id)}>
                  <CheckCircle className="w-4 h-4 mr-2" /> Publier
                </DropdownMenuItem>
              )}
              {(isAdmin || (report.status !== 'published' && report.status !== 'sent')) && (
                <DropdownMenuItem onClick={() => onDelete(report)} className="text-red-600 focus:text-red-600">
                  <Trash2 className="w-4 h-4 mr-2" /> Supprimer
                </DropdownMenuItem>
              )}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </div>
  );
}
